/* eslint-disable no-unused-vars */
/* eslint-disable semi */
import { safeDeepGet } from 'iotera-base/utility/json';
import Base from './base';

export default class Distributor  extends Base {
  constructor(firebase, applicationId) {
    super(firebase, applicationId, 'discount');
  }

  list = () => {
    return new Promise((resolve, reject) => {
      const list = {};
      this.collection.get().then(
        querySnapshot => {
          querySnapshot.docs.map(doc => {
            list[doc.id] = doc.data();
          });
          resolve({ code: 0, body: list });
        },
        error => {
          resolve({ code: -1, body: list });
        }
      );
    });
  };

  create = payload => {
    return new Promise((resolve, reject) => {
      delete payload.pass;
      const insertedPayload = {};
      for (const key in payload) {
        if (
          key === 'device_id' ||
          key === 'sku' ||
          key === 'created_ts' ||
          key === 'expired_ts' ||
          key === 'active' ||
          key === 'discount'
        ) {
          insertedPayload[key] = payload[key];
        }
      }
      const device_id = payload['device_id'];
      const sku = payload['sku'];
      const id = device_id + '_' + sku;
      insertedPayload['id'] = id

      this.collection
        .doc(id)
        .set(insertedPayload)
        .then(
          () => {
            resolve({ code: 0 });
          },
          error => {
            resolve({ code: -1, body: error });
          }
        );
    });
  };

  read = sku => {
    return new Promise((resolve, reject) => {
      let map = {};
      this.collection
        .where('sku', '==', sku)
        .get()
        .then(
          querySnapshot => {
            let code = -1;
            if (querySnapshot.size > 0) {
              code = 0;
              map = { ...querySnapshot.docs[0].data() };
            }
            resolve({ code: code, body: map });
          },
          error => {
            resolve({ code: -1, body: map });
          }
        );
    });
  };

  update = payload => {
    return new Promise((resolve, reject) => {
      const updatedPayload = {};
      for (const key in payload) {
        if (
          key === 'device_id' ||
          key === 'sku' ||
          key === 'created_ts' ||
          key === 'expired_ts' ||
          key === 'active'
        ) {
          updatedPayload[key] = payload[key];
        }
      }
      const device_id = payload['device_id'];
      const sku = payload['sku'];
      const id = safeDeepGet(payload, 'id' ,device_id + '_' + sku);
      updatedPayload['id'] = id
      this.collection
        .doc(id)
        .set(
          {
            active: false,
          },
          { merge: true }
        )
        .then(
          () => {
            resolve({ code: 0 });
          },
          error => {
            resolve({ code: -1, body: error });
          }
        );
    });
  };

  delete_ = payload => {
    return new Promise((resolve, reject) => {
      const device_id = payload['device_id'];
      const sku = payload['sku'];
      const id = safeDeepGet(payload, 'id', device_id + '_' + sku ); 
      this.collection
        .doc(id)
        .delete()
        .then(
          () => {
            resolve({ code: 0 });
          },
          error => {
            resolve({ code: -1, body: error });
          }
        );
    });
  };
}
